import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MainSidebarState {
  public collapsed$ = new BehaviorSubject<boolean>(true);
  public mobileOpened$ = new BehaviorSubject<boolean>(false);

  public toggle(): void {
    this.collapsed$.next(!this.collapsed$.value);
  }

  public openMobile(): void {
    this.mobileOpened$.next(true);
  }

  public closeMobile(): void {
    this.mobileOpened$.next(false);
  }
}
